import * as React from 'react';
import DialogContentText from '@mui/material/DialogContentText';
import { TApiQuestionEntity } from '../../types/Survey';

interface IQuestionHelpTextInlineProps {
  question: TApiQuestionEntity;
}

const QuestionHelpTextInline: React.FC<IQuestionHelpTextInlineProps> = ({
  question,
}): JSX.Element | null => {
  if (!question.helpTextInline || !question.helpText) {
    return null;
  }

  return (
    <DialogContentText
      component='div'
      sx={{
        textAlign: 'left',
        marginBottom: '8px',
        '& > :first-child': { marginTop: 0 },
        '& > :last-child': { marginBottom: 0 },
      }}
      dangerouslySetInnerHTML={{ __html: question.helpText }}
    />
  );
};

export default QuestionHelpTextInline;
